import type { LottieSource } from './use-lottie-source.types';

export const getRemoteDotLottieUri = (source?: LottieSource): string | undefined => {
  const candidate =
    typeof source === 'string'
      ? source
      : source && typeof source === 'object' && 'uri' in source
      ? source.uri
      : undefined;

  if (!candidate) {
    return undefined;
  }

  try {
    const url = new URL(candidate);
    if (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.pathname.toLowerCase().endsWith('.lottie')
    ) {
      return url.toString();
    }
  } catch {
    return undefined;
  }

  return undefined;
};
